<template>
<div>
  <h6>Standard Data Upload</h6>
  <div v-if="state === 'CHECK'">
    <b-alert id='user-reminder' variant="info" show>Do you wish to run task to import data from file?</b-alert>
    <b-button class="btn-xs" variant="primary" v-on:click.prevent="state = 'DEFAULT'">No</b-button>
    <b-button class="btn-xs" variant="primary" v-on:click.prevent="addTask">Yes</b-button>
  </div>
  <b-form-file v-if="state === 'DEFAULT'" accept=".zip" v-model="file" placeholder="Choose a file..."></b-form-file>
  <div class="upload-check-container" v-if="file">
    <span>Upload this file?</span>
    <b-button type="submit" variant="primary" @click="upload">Upload</b-button>
  </div>

</div>
</template>
<script>
import Vue from 'vue'
import TasksPlugin from '../../../plugin/tasks'

export default {
  data() {
    return {
      file: null,
      scripts: [],
      state: 'DEFAULT'
    }
  },
  computed: {
    currentProject () {
      return this.$store.getters['project/currentProject']
    }
  },
  mounted () {
    Vue.use(TasksPlugin)
    this.$tasksService.loadScripts(this)
  },
  methods: {
    upload() {
      let user = this.$store.getters['user/user']
      let formData = new FormData();
      formData.append('file', this.file);
      let me = this
      this.$http.post('/api/admin-board/upload-standard-data/?user_name='+user.username, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(res => {
        this.$notify({
          title: 'SUCCESS',
          text: 'Data upload successful',
          type: 'success'
        })
        me.file = null
        me.state = 'CHECK'
      }, res => {
        this.$notify({
          title: 'ERROR',
          text: 'Could not upload data',
          type: 'error'
        })
        this.loading = false
      })
    },
    addTask () {
      let payload = {}
      this.state = 'DEFAULT'
      // TODO get required task id and add to payload
      // payload['ids'] = Object.keys(this.tasksToAdd).filter(k => this.tasksToAdd[k]).map(id => parseInt(id))
      // payload['project_id'] = this.currentProject.id
      // payload['workpack_id'] = this.currentProject.workpack.id

      // this.$tasksService.addTasks(this, payload)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/user/admin/StandardDataUpload.vue